webpackJsonp([249675431891645],{

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/weed-control.bcdddea6.jpg";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(19);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _landscapeDevelopment = __webpack_require__(28);
	
	var _landscapeDevelopment2 = _interopRequireDefault(_landscapeDevelopment);
	
	var _weedControl = __webpack_require__(129);
	
	var _weedControl2 = _interopRequireDefault(_weedControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TurfFertilization = function TurfFertilization() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Turf & Field Maintenance | ICE Enterprises'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subBackground' },
	      _react2.default.createElement('img', { src: _landscapeDevelopment2.default })
	    ),
	    _react2.default.createElement(
	      'header',
	      { className: 'sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'headerTitle' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Turf Fertilization'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We offer a wide range of custom solutions.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { className: 'col' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pagination' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Home'
	        ),
	        ' > ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/services' },
	          'Services'
	        ),
	        ' > Turf Fertilization'
	      ),
	      _react2.default.createElement('img', { src: _weedControl2.default, alt: 'Turf & Field maintenance project in Wisconsin' }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Advanced nutrition management'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Turf Fertilization is a maintenance solution that requires advanced nutrient management in order to allow the growth of thick + healthy grass. It\u2019s a solution that\u2019s helpful for all customers from small residential plots to professional athletic fields.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Tailored Fertilzation'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Every lawn gets a specialized solution and treatment. Many companies offer a \u20181 size fits all\u2019 solution that throws away the potential of your lawn. At ICE we believe in maximizing your lawns potential to grow the thickest and healthiest grass possible. Our solutions range from the basic, to multiple applications with aerations and pesticides.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:estimates@ice2010.com', target: '__blank' },
	          'Contact us today'
	        ),
	        ' to see how we can help your lawn'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'caller' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Contact us today and learn more'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          null,
	          '(815) 271-0368'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button', href: 'mailto:estimates@ice2010.com' },
	          'estimates@ice2010.com'
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { color: 'purple' })
	  );
	};
	
	exports.default = TurfFertilization;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-turf-fertilization-js-b6e390a341fded51fa35.js